import { render, staticRenderFns } from "./ClientSingle.vue?vue&type=template&id=f62c88f0&"
import script from "./ClientSingle.vue?vue&type=script&lang=js&"
export * from "./ClientSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientSingle.vue"
export default component.exports